import * as React from 'react'

import { Box, Icon, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { DataTableProjection } from 'generated/resources/datatable.graphql'

type Props<T, S extends string> = {
  projection: DataTableProjection<T, S>
  onToggle?: (value: boolean) => void
  active: boolean
  sortable?: boolean
}

export default function Field<T, S extends string>({
  projection,
  onToggle,
  active,
  sortable,
}: Props<T, S>) {
  if (!('title' in projection)) {
    return null
  }

  const { title } = projection
  return (
    <Box
      width="full"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      paddingY="s16"
      paddingLeft="s4" // This should be s24, but the sortable list has a left element that occupies it
      paddingRight="s24"
      gap="s12"
    >
      <Box flexDirection="row" gap="s4" alignItems="center">
        <Box width="s24">{sortable && <Icon.Medium icon="drag-and-drop" />}</Box>
        <Text.Normal>{title}</Text.Normal>
      </Box>
      <TogglerCheckbox value={active} onChange={onToggle} disabled={!onToggle} />
    </Box>
  )
}
